import { type FC } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionStack,
  AccordionSummary,
} from 'base-ui'

import { ErxBonusLandingPageFaqData } from './ErxBonusLandingPageFaqData'

export const ErxBonusLandingPageFaqAccordion: FC = () => {
  return (
    <AccordionStack>
      {ErxBonusLandingPageFaqData.map(({ details, key, summary }) => (
        <Accordion
          itemProp="mainEntity"
          itemScope
          itemType="https://schema.org/Question"
          key={key}
        >
          <AccordionSummary itemProp="name">{summary}</AccordionSummary>
          <AccordionDetails
            className="prose"
            itemProp="acceptedAnswer"
            itemScope
            itemType="https://schema.org/Answer"
          >
            <div itemProp="text">{details}</div>
          </AccordionDetails>
        </Accordion>
      ))}
    </AccordionStack>
  )
}
